<div [formGroup]="formGroup">
    <label [for]="controlName" class="form-control-label">
        {{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
        <sume-help-tooltip
            *ngIf="helpMessage"
            [message]="helpMessage"
            placement="right"
            size="small">
        </sume-help-tooltip>
    </label>
    <div class="input-group">
        <input
            type="text"
            [(bsValue)]="value"
            (bsValueChange)="onDateChange($event)"
            autocomplete="off"
            class="form-control"
            placeholder="dd/mm/aaaa"
            mask="00/00/0000"
            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
            bsDatepicker
            [disabled]="formControl.disabled"
            [ngClass]="{
                'is-invalid':
                    formControl?.invalid &&
                    (formControl?.dirty || formControl?.touched || changeText)
            }" />
        <div class="invalid-feedback">
            {{ messages?.invalid || 'Data inválida' }}
        </div>
    </div>
</div>
